import React, { Fragment } from 'react'

import Weather from './Weather_App/Weather';





function App() {
  return (
    <Fragment>
        <Weather/>
    </Fragment>
  )
}

export default App
